// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"aa812080","466":"aa812080","510":"c69b325b"}[chunkId] + ".chunk.css";
};